import api from '@shared/services/api';

export const basisTerminationService = {
    getBasisTerminationById: async (id) => {
        const response = await api.get(`/hr-leave-law-reasons/${id}`);
        return response.data;
    },
    getBasisTerminations: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.pageNumber !== undefined) queryParams.append('pageNumber', params.pageNumber);
        if (params.pageSize !== undefined) queryParams.append('pageSize', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDir) queryParams.append('sortDir', params.sortDir);
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-leave-law-reasons${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data;
    },
    getHrNssiReasons: async () => {
        const response = await api.get('/hr-nssi-reason/3');
        return response.data;
    },
    getReasonLeaving: async () => {
        const response = await api.get('/hr-reason-leaving');
        return response.data;
    },
    getReasonLeavingById: async (id) => {
        const response = await api.get(`/hr-reason-leaving/${id}`);
        return response.data;
    },
    createReasonLeaving: async (data) => {
        const response = await api.post('/hr-reason-leaving', data);
        return response.data;
    },
    updateReasonLeaving: async (id, data) => {
        const response = await api.put(`/hr-reason-leaving/${id}`, data);
        return response.data;
    },
    deleteReasonLeaving: async (id) => {
        const response = await api.delete(`/hr-reason-leaving/${id}`);
        return response.data;
    },
    createBasisTermination: async (data) => {
        const response = await api.post('/hr-leave-law-reasons', data);
        return response.data;
    },
    updateBasisTermination: async (id, data) => {
        const response = await api.put(`/hr-leave-law-reasons/${id}`, data);
        return response.data;
    },
    deleteBasisTermination: async (id) => {
        const response = await api.delete(`/hr-leave-law-reasons/${id}`);
        return response.data;
    },
    getBasisTerminationsReportData: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-leave-law-reasons/report${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data || [];
    },
    getTranslation: async (id) => {
        const response = await api.get(`/hr-leave-law-reasons/translation/${id}`);
        return response.data;
    },
    saveTranslation: async (data) => {
        const response = await api.post('/hr-leave-law-reasons/translate', data);
        return response.data;
    },
};

